import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const TitleWrapper = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "16px",
  letterSpacing: "0.4px",
  color: colors.gray600,
}));
